const { default: Styled } = require('styled-components');
const internals = {};

internals.leaderColors = {
    Gold: ['#fff2a3', '#e9b92f', '#ad7713'],
    Silver: ['#f5faff', '#b2c3d5', '#77899e'],
    Bronze: ['#ffe0bd', '#cf935d', '#955b32']
};
module.exports = Styled.div`
    box-sizing: border-box; position: relative; width: 100%; max-width: 190px; margin: 0 auto; border-radius: 17px;
    padding: ${(props) => props.$outside ? 0 : props.$metal ? 5 : 0}px;
    ${(props) => {

        const colors = internals.leaderColors[props.$metal];
        if (props.$outside) {
            const background = colors ? `linear-gradient(135deg, ${colors[2]} 0%, ${colors[0]} 22%, ${colors[1]} 42%, ${colors[0]} 51%, ${colors[2]} 70%, ${colors[0]} 88%, ${colors[1]} 100%)` : 'transparent';
            return `isolation: isolate;
                &::before { content: ''; position: absolute; inset: -5px; border-radius: inherit; background: ${background}; opacity: ${colors ? 1 : 0}; transition: opacity 180ms ease; pointer-events: none; z-index: -1; }
                & > .sparkle { opacity: ${colors ? 1 : 0}; transition: opacity 180ms ease; }
                @media (prefers-reduced-motion: reduce) { &::before, & > .sparkle { transition: none; } }`;
        }

        return colors ? `background: linear-gradient(135deg, ${colors[2]} 0%, ${colors[0]} 22%, ${colors[1]} 42%, ${colors[0]} 51%, ${colors[2]} 70%, ${colors[0]} 88%, ${colors[1]} 100%); box-shadow: 0 0 0 1px ${colors[2]}, 0 2px 8px ${colors[1]}66; color: ${colors[2]};` : '';
    }}
    img { display: block; max-width: none; }
    .sparkle { position: absolute; font-size: 25px; line-height: 1; color: #fff9df; text-shadow: 0 0 2px currentColor, 0 0 4px #8c7038; pointer-events: none; }
    .sparkle-top { top: -8px; right: 8px; }
    .sparkle-bottom { bottom: 9px; left: -7px; font-size: 20px; }
    .leader-label { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }
`;
